
(function() {
  var result = { translations: { "sl": { "i18n": { "duration": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ur", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} minut", "hours": "{{ hours }} ur", "days": "{{ days }} dni", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, zun. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "sl": "static-7.1332"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1332",
    "ar-eg": "static-7.1332",
    "bg": "static-7.1332",
    "bn": "static-7.1332",
    "ca-es": "static-7.1332",
    "cs": "static-7.1332",
    "da": "static-7.1332",
    "de": "static-7.1332",
    "el": "static-7.1332",
    "en-gb": "static-7.1332",
    "en": "static-7.1332",
    "es-mx": "static-7.1332",
    "es": "static-7.1332",
    "et": "static-7.1332",
    "fi": "static-7.1332",
    "fr-ca": "static-7.1332",
    "fr": "static-7.1332",
    "he-il": "static-7.1332",
    "hi": "static-7.1332",
    "hr": "static-7.1332",
    "hu": "static-7.1332",
    "id": "static-7.1332",
    "it": "static-7.1332",
    "ja": "static-7.1332",
    "ko": "static-7.1332",
    "lt": "static-7.1332",
    "ms": "static-7.1332",
    "nl": "static-7.1332",
    "no": "static-7.1332",
    "pl": "static-7.1332",
    "pt-br": "static-7.1332",
    "pt-pt": "static-7.1332",
    "ro": "static-7.1332",
    "ru": "static-7.1332",
    "sk": "static-7.1332",
    "sl": "static-7.1332",
    "sv": "static-7.1332",
    "th": "static-7.1332",
    "tl": "static-7.1332",
    "tr": "static-7.1332",
    "uk": "static-7.1332",
    "vi": "static-7.1332",
    "x-pseudo": "static-7.1332",
    "zh-cn": "static-7.1332",
    "zh-hk": "static-7.1332",
    "zh-tw": "static-7.1332"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sl', {version: 'static-7.1332'}); }
})();


